import {useState} from "react";

import Header from "./components/Layout/Header";
import Meals from "./components/Meals/Meals";
import Cart from "./components/Cart/Cart";
import CartProvider from "./store/CartProvider";
import Footer from "./components/Layout/Footer";


function App() {

    const [modalOpen, setModalOpen] = useState(false);

    const showCartHandler = () => {
        setModalOpen(true);
    }

    const hideCartHandler = () => {
        setModalOpen(false);
    }

    return (
        <CartProvider>
            { modalOpen && <Cart onClose={hideCartHandler}/> }
            <Header onShowCart={showCartHandler} />
            <main><Meals/></main>
            <Footer/>
        </CartProvider>
    );
}

export default App;
